// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1ii7kb7n{grid-row:1}\n._yyhykb7n{grid-column:1}._18m915vq{overflow-y:hidden}\n._1bsbidpf{width:0}\n._1e0c11p5{display:grid}\n._1reo15vq{overflow-x:hidden}\n._2z05hkll{grid-template-rows:1fr}\n._ca0qu2gc{padding-top:var(--ds-space-100,8px)}\n._ca0qutpp{padding-top:var(--ds-space-150,9pt)}\n._kqswh2mm{position:relative}\n._lcxvglyw{pointer-events:none}\n._y3gn1h6o{text-align:center}\n._yv0ehkll{grid-template-columns:1fr}", ""]);
// Exports
module.exports = exports;
